import { useMutation } from '@tanstack/vue-query'
import { httpRequest } from '@shared/api/httpRequests'
import { urlSubst } from '@shared/utils/url'

/**
 * @constant {string} BASE_URL Base URL path
 */
export const BASE_URL = '/ic-applications/api/v1'

/**
 * @constant {Object.<string:string>} API Map of API CRUD methods and their relative URLs (not including BASE_URL)
 */
export const API = {
  EXPORT_ORDERS: '/queue/file',
  EXPORT_PROJECTS: '/applications/file',
  GET_ORDERS: '/queue',
  GET_PROJECTS: '/applications',
}

/**
 * @constant {Object.<string:string>} PROJECTS_API Map of API CRUD methods and their URLs (including BASE_URL)
 */
export const PROJECTS_API = Object.fromEntries(
  Object.entries(API).map(([key, val]) => [key, `${BASE_URL}${val}`]),
)
// queue page vars is using an api v2 endpoint
PROJECTS_API.QUEUE_PAGE_VARS = '/ic-applications/api/v2/queue'

/**
 * @constant {Object.<string:string>} ACTIONS_URLS Map of actions API relative URLs (not including BASE_URL)
 */
export const ACTIONS_URLS = {
  APPLY_BULK_ACTION: 'Useraction/1/:workflowId/Start?appIds=:appIds',
  DELETE_FILTER: 'FilterPreset/A/:payloadId',
  LOAD_AVAILABLE_FIELDS: 'Queue/1/Applications/filter/availableFields',
  LOAD_AVAILABLE_OPTIONS: 'Queue/1/Applications/filter/availableOptions',
  LOAD_BULK_USER_ACTIONS: 'Useraction/1/UserActions?filter=:override',
  LOAD_FILTER_PRESETS: 'FilterPreset/A/?scope=queueDetail.ua-toolbar',
  LOAD_USER_ACTIONS: 'Useraction/1/UserActions?filter=:override',
  SAVE_FILTER: 'FilterPreset/A/:payloadId',
  TRIGGER_LEGACY_RULE: '/Queue/1/PageEvent/:ruleId',
}

export function triggerLegacyRule (mutationOptions = {}) {
  const mutationFn = async ({ ruleId, ruleParams = {} }) => {
    const data = await httpRequest({
      method: 'POST',
      baseURL: '/',
      url: urlSubst(ACTIONS_URLS.TRIGGER_LEGACY_RULE, { ruleId }),
      data: ruleParams,
    })

    if (!data || data.enum == null) throw new Error('Invalid server response!')
    if (data.enum.error) throw new Error(data.enum.error)

    return data.enum
  }

  return useMutation({ mutationFn, ...mutationOptions })
}
